import { render } from "./PsLine.vue?vue&type=template&id=1d3b358e&ts=true"
import script from "./PsLine.vue?vue&type=script&lang=ts"
export * from "./PsLine.vue?vue&type=script&lang=ts"

import exportComponent from "/home/jstechno-26/projects/Barting-Coin/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__